import React from "react";
import Checkbox from "components/Checkbox";
import TextField from "@mui/material/TextField";
import Autocomplete from '@mui/material/Autocomplete';

const styles = {
  fontSize: "14px",
};

export default function CheckboxTableField(props) {
  return (
    <Autocomplete
      multiple={props.multiple}
      size="small"
      value={props.value}
      options={props.options}
      onChange={props.onChange}
      disableCloseOnSelect
      disableClearable
      isOptionEqualToValue={(option, value) => {
        return option["id"] === value["id"];
      }}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option, { selected }) => (
        <li {...props} key={option.id}>
          <Checkbox style={{ marginRight: 8 }} checked={selected} />
          <div style={styles}>{option.name}</div>
        </li>
      )}
      renderInput={(params) => <TextField {...params} />}
    />
  );
}
